import { IStore } from 'store/types';
import { IdentityType, IIdentity } from 'types';
import { hasVerifiedIdentityType } from 'utils/identity';

export const selectCurrentUser = () => (state: IStore) => state.user;

export const selectCurrentUserIdentities = () => (state: IStore) => state.user?.identities;

export const selectCurrentUserCard = () => (state: IStore) => state.user?.cardDetail;

export const hasEmailRegistered = () => (state: IStore) => hasVerifiedIdentityType(state.user?.identities, IdentityType.EMAIL);

export const hasMobileRegistered = () => (state: IStore) => hasVerifiedIdentityType(state.user?.identities, IdentityType.MOBILE);

export const selectUserInvites = (state: IStore) => state?.user?.invites;

export const selectVerifiedIdentities =
  () =>
  (state: IStore): IIdentity[] =>
    (state?.user?.identities || []).filter((id) => id.verified);
